/// <amd-module name="Wit/WorkItemForm/Links/GitHub/GitHubCommitSelection" />
import { IVssPageContext } from "VSS/Platform/Context";
import { FormItem } from "VSSUI/FormItem";
import { ExternalGitCommit, ExternalGitRepo } from "Wit/Clients/Internal/Contracts/ExternalEvents";
import * as Resources from "Wit/WorkItemForm/Resources";
import * as React from "react";
import { GitHubArtifactDropdownWithInfiniteScrolling } from "./GitHubArtifactDropdownWithInfiniteScrolling";

interface IGitHubCommitSelectionProps {
    pageContext: IVssPageContext;
    selectedRepository?: ExternalGitRepo;
    selectedCommit: ExternalGitCommit | undefined;
    setSelectedCommit: (commit: ExternalGitCommit | undefined) => void;
    setShowSetUrlManually: (value: boolean) => void;
    cacheGitHubArtifactsFFEnabled?: boolean;
}

export const GitHubCommitSelection: React.FC<IGitHubCommitSelectionProps> = props => {
    return (
        <FormItem label={Resources.GithubCommitLabel}>
            <GitHubArtifactDropdownWithInfiniteScrolling<ExternalGitCommit>
                pageContext={props.pageContext}
                selectedArtifact={props.selectedCommit}
                setSelectedArtifact={props.setSelectedCommit}
                dropdownIconName="BranchCommit"
                dropdownId="sha"
                dropdownText={["message"]}
                infiniteScrollingDataProviderId="ms.vss-work-web.github-commits-data-provider"
                cacheArtifacts={props.cacheGitHubArtifactsFFEnabled}
                setShowSetUrlManually={props.setShowSetUrlManually}
                resources={{
                    noResultsMessage: Resources.GithubCommitsEmptyMessage,
                    loadingMessage: Resources.GithubCommitsLoadingMessage,
                    loadingFailedMessage: Resources.GithubCommitsLoadingFailedMessage,
                    entities: Resources.GithubCommits
                }}
                requireGitHubRepositoryContext
                gitHubRepositoryContext={props.selectedRepository}
            />
        </FormItem>
    );
};
